import script from "./MsPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./MsPopover.vue?vue&type=script&setup=true&lang=js"

import "./MsPopover.vue?vue&type=style&index=0&id=f3307c1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3307c1e"]])

export default __exports__